const collectionCards = document.querySelector('.custom-collection-cards');
const loading = document.querySelector('.custom-loading');

let pageNumber = 2;
let isFinish = false;
let isRequest = false;

window.addEventListener('scroll', () => {
	if (isRequest || isFinish) return;

	const scrollY = window.scrollY || document.documentElement.scrollTop;

	const cardsRect = collectionCards.getBoundingClientRect();
	const cardsBottom = cardsRect.bottom + scrollY;

	const windowHeight =
		window.innerHeight || document.documentElement.clientHeight;

	if (cardsBottom <= scrollY + windowHeight) {
		isRequest = true;

		loading.classList.add('custom-loading--active');

		const url =
			collectionCards.dataset.nextDataUrl.slice(0, -2) + '=' + pageNumber;

		fetch(url)
			.then(response => response.text())
			.then(data => {
				const parser = new DOMParser();
				const document = parser.parseFromString(data, 'text/html');

				const cards = document.querySelectorAll('.custom-product-card');

				if (!cards.length) {
					isFinish = true;

					return;
				}

				cards.forEach(card => {
					collectionCards.appendChild(card);
				});

				pageNumber++;
			})
			.finally(() => {
				isRequest = false;

				loading.classList.remove('custom-loading--active');
			});
	}
});
